import clsx from 'clsx';
import { useCallback } from 'react';
import Link from 'next/link';
import Tooltip from '@/components/Tooltip';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const LineNav = _ref => {
  let {
    links = [],
    active = '',
    notice = '',
    className,
    onOpen
  } = _ref;
  const handleLinkClick = useCallback((evt, href) => {
    if (onOpen) {
      onOpen(href);
      evt.preventDefault();
    }
  }, [onOpen]);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.container, className || ''),
    "data-active": active,
    children: links.map(link => /*#__PURE__*/_jsx("li", {
      children: link.tooltip ? /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        className: styles.tooltipConainer,
        tooltipClassName: styles.tooltip,
        content: link.tooltip,
        children: /*#__PURE__*/_jsx(LineNavLink, {
          link: link,
          active: active,
          notice: notice,
          handleLinkClick: handleLinkClick
        })
      }) : /*#__PURE__*/_jsx(LineNavLink, {
        link: link,
        active: active,
        notice: notice,
        handleLinkClick: handleLinkClick
      })
    }, link.href))
  });
};

export default LineNav;

const LineNavLink = _ref2 => {
  let {
    link,
    active,
    notice,
    handleLinkClick
  } = _ref2;
  return /*#__PURE__*/_jsx(Link, {
    className: clsx(styles.link, link.href === active ? styles['-active'] : '', link.href === notice ? styles['-notice'] : ''),
    onClick: evt => handleLinkClick(evt, link.href),
    href: link.href,
    children: link.text
  });
};